module.exports = __webpack_public_path__ + "static/media/logo-notifica.1a8c5ae2.png";